<template>
  <div class="x-flex x-flex-col x-gap-12">
    <h1 class="x-title3 x-text-lead-75">
      {{ $t('nextQueries.title') }}
    </h1>
    <NextQueries
      :animation="animation"
      :max-items-to-render="3"
      class="x-flex x-gap-8 desktop:!x-flex-col desktop:x-gap-4"
      :class="{ '!x-flex-row !x-flex-wrap': !x.query.searchBox }"
    >
      <template #suggestion="{ suggestion }">
        <NextQuery
          :class="`x-suggestion x-suggestion-md x-text2 !x-text2-lg x-font-light x-text-lead-75 ${suggestionClass}`"
          :suggestion="suggestion"
        >
          <CuratedCheckIcon v-if="suggestion.isCurated" class="x-icon-lg desktop:x-icon-md" />
          <LightBulbOn v-else class="x-icon-lg desktop:x-icon-md" />
          <span>{{ suggestion.query }}</span>
        </NextQuery>
      </template>
    </NextQueries>
  </div>
</template>

<script setup lang="ts">
import type { AnimationProp } from '@empathyco/x-components'
import { CuratedCheckIcon, LightBulbOn, use$x } from '@empathyco/x-components'
import { NextQueries, NextQuery } from '@empathyco/x-components/next-queries'
import { computed } from 'vue'
import { useDevice } from '../../composables/use-device.composable'

defineProps<{
  animation: typeof AnimationProp
}>()
const { isDesktopOrGreater } = useDevice()
const x = use$x()

const suggestionClass = computed(() =>
  !isDesktopOrGreater.value && !x.query.searchBox
    ? 'x-px-12 x-border-1 x-border-neutral-25 x-items-baseline'
    : '',
)
</script>
<style lang="scss"></style>
